module.exports = __webpack_public_path__ + "static/media/questionAnswerAuthorImage.31b4c38e.svg";